export default {
  back: {
    id: 'asp_action_bar_navigation_back',
    defaultMessage: 'Back',
  },
  exit: {
    id: 'asp_action_bar_navigation_exit',
    defaultMessage: 'Exit',
  },
}
